var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',{staticClass:"bounds"},[_c('video',{staticClass:"image",attrs:{"src":_vm.video,"controls":"","playsinline":""}})]),_c('div',{staticClass:"download"},[_c(_setup.AppButton,{attrs:{"color":"gradient","size":"large","href":_vm.video,"download":"video.mp4"}},[_vm._v("Download Video")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }